import { TGRPCPromiseReject } from '@monorepo/grpc';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';
import { User } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { CreateUserRequest } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { useMutation } from '@tanstack/react-query';

const useCreateTemporaryUser = () => {
  const request = useGetRequest(REQUEST_TYPES.CREATE_TEMPORARY_USER);

  return useMutation<
    Partial<User.AsObject> | null,
    TGRPCPromiseReject,
    CreateUserRequest.AsObject
  >({ mutationFn: request, retry: false });
};

export default useCreateTemporaryUser;
